import React from 'react'
import Modal from './Modal'
import "./ModalDisabledCameraCalibration.css";

type Props = {
  headerText: string;
  bodyText: string;
  show: boolean;
  onClickOk?: () => void;
}

const ModalDisabledCameraCalibration = ({show, headerText, bodyText, onClickOk}: Props) => {
  return (
    <Modal
      show={show}
      hideOnBackdropClick={false}
      className="modal-disabled-notification"
    >
      <Modal.Header
        title={headerText}
        hideButtonEnabled={false}
        className="modal-disabled-notification-header"
        titleStyle={{color: 'black'}}
      />
     <Modal.Body className="modal-disabled-notification-body">
        <div className="modal-disabled-notification-subtittle">{bodyText}</div>
      </Modal.Body>
      <Modal.Footer
        className="modal-disabled-notification-footer"
        onClickOk={onClickOk}
        styleOkButton={{width: '100px'}}
      />
    </Modal>
  )
}

export default ModalDisabledCameraCalibration